import instance from "@/services/api";

export const geodesistCallsAPI = {
  async getGeodesistCalls(params) {
    return await instance()
      .get(`/project/geodesist/calls/read/`, { params })
      .then((res) => res?.data);
  },
  async addGeodesistDoc(formData) {
    return await instance()
      .post(`/project/geodesist/doc/add/`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => res?.data);
  },
};
